import React from 'react';

export const DIALOGS_PORTAL_ID = 'dialogs-portal';

// Component to which dialogs/portals should be rendered
export const DialogsPortal = () => <div id={DIALOGS_PORTAL_ID} />;
